import { Link, Outlet } from 'react-router-dom';
import { strings } from '@/i18n/strings';
import { Footer } from '@components/__shared/Footer/Footer';
import { Logo } from '@components/__shared/Logo/Logo';
import { Nav } from '@components/__shared/Nav/Nav';
import styles from './PublicLayout.module.scss';

export const PublicLayout = () => (
	<div className={styles.app}>
		<header className={styles.header}>
			<div className={styles.headerInner}>
				<Link to="/" className={styles.brand} aria-label={strings.logo.homeAriaLabel}>
					<Logo size={44} />
				</Link>
				<Nav />
			</div>
		</header>

		<main className={styles.main}>
			<Outlet />
		</main>

		<Footer />
	</div>
);
